import { useEffect, useState } from "react";
import { useStore } from "@/store";
import { Navigate, Outlet } from "react-router-dom";

const AdminProtectedRoute = ({ children }) => {
  const loggedInUser = useStore((state) => state.loggedInUser);
  const [isHydrated, setIsHydrated] = useState(
    () => useStore.persist?.hasHydrated?.() || false,
  );

  useEffect(() => {
    const finishHydration = useStore.persist?.onFinishHydration?.(() =>
      setIsHydrated(true),
    );
    const startHydration = useStore.persist?.onHydrate?.(() =>
      setIsHydrated(false),
    );

    return () => {
      finishHydration?.();
      startHydration?.();
    };
  }, []);

  // Fallback a datos persistidos para navegaciones iniciales antes de hidratar el store
  let persistedUser = null;
  try {
    const rawStore = localStorage.getItem("store");
    if (rawStore) {
      const maybeParsed = JSON.parse(rawStore);
      const parsed =
        typeof maybeParsed === "string" ? JSON.parse(maybeParsed) : maybeParsed;

      persistedUser = parsed?.state?.loggedInUser || parsed?.loggedInUser || null;
    }
  } catch (error) {
    console.error("Error leyendo el usuario persistido:", error);
  }

  const effectiveUser = loggedInUser?.roles?.length ? loggedInUser : persistedUser;

  useEffect(() => {
    if (!loggedInUser?.roles?.length && persistedUser?.roles?.length) {
      useStore.setState((state) => ({
        ...state,
        loggedInUser: persistedUser,
      }));
    }
  }, [loggedInUser, persistedUser]);

  const isAdminRole = () =>
    effectiveUser?.roles?.some(
      (role) => role === "admin" || role === "superadmin",
    ) || false;

  // Evitar redirigir mientras el store aún no se hidrata y no tenemos datos
  if (!isHydrated && !effectiveUser) {
    return null;
  }

  if (!isAdminRole()) {
    return <Navigate to="/" replace={true} />;
  }
  return children ? children : <Outlet />;
};

export default AdminProtectedRoute;
